// smoothscroll for links with hash
$(() => {
  const animateScrollDuration = 500;
  function getCssOffsetTop() {
    let offsetTop = window.getComputedStyle(document.body).getPropertyValue('--frame-space-extra-small');

    if (!Number.isNaN(parseFloat(offsetTop))) {
      if (offsetTop.includes('rem') || offsetTop.includes('em')) {
        const fontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
        offsetTop = parseFloat(offsetTop) * fontSize;
      } else {
        offsetTop = parseFloat(offsetTop);
      }
    } else {
      offsetTop = $('#page-header .wrapper-navbar').outerHeight();
    }

    return offsetTop;
  }

  // @fixme avoid to kill standard bs4 functionality like collapse elements
  // eslint-disable-next-line func-names
  $(document).on('click', 'a:not(.mm-blocker)', function () {
    // Make sure this.hash has a value before overriding default behavior
    if (
      this.hash !== ''
      && $(this).parents('.mm-menu').length === 0
      && $(this).not('[data-bs-target]').length === 1
    ) {
      // Store hash
      const { hash } = this;
      const animateTo = $(hash).offset().top - getCssOffsetTop();
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll
      // to the specified area
      $('html, body').animate({
        scrollTop: animateTo,
      }, animateScrollDuration, () => {
        // Add hash (#) to URL when done scrolling (default click behavior)
        if (window.history.pushState) {
          // IE10, Firefox, Chrome, etc.
          window.history.pushState(null, null, hash);
        } else {
          window.location.hash = hash;
        }
      });
      return false;
    } // End if
    return true;
  });

  $('button[data-bs-toggle="collapse"][data-bs-target]:not(.hm-combo-search-btn-filter-toggle)').each((i, e) => {
    const bsTarget = $(e).attr('data-bs-target');
    const hash = `#${$(e).parents('.frame-container').attr('id')}`;

    if ($(e).parents('.frame-container').length > 0) {
      $(bsTarget).on('shown.bs.collapse', () => {
        const pageHeaderHeight = $('#page-header .wrapper-navbar').outerHeight();

        $('html, body').animate({
          scrollTop: $(e).offset().top - pageHeaderHeight,
        }, animateScrollDuration, () => {
          // Add hash (#) to URL when done scrolling (default click behavior)
          if (window.history.pushState) {
            // IE10, Firefox, Chrome, etc.
            window.history.pushState(null, null, hash);
          } else {
            window.location.hash = hash;
          }
        });
      });
    }
  });

  $(document).on('click', '.vacancy-application .tab-pane [data-step="next"], .vacancy-application .tab-pane [data-api-application="submit"]', (e) => {
    const applicationTabContent = $(e.target).parents('.tab-content').first();
    const animateTo = applicationTabContent.offset().top - getCssOffsetTop();

    // scroll to upper edge of tab content wrapper if scroll position is to low
    if (window.scrollY > animateTo) {
      $('html, body').animate({
        scrollTop: animateTo,
      }, animateScrollDuration);
    }
  });
});
